var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"table",staticClass:"common-el-table-styles summary-el-table-styles",attrs:{"border":"","stripe":"","show-summary":"","data":_vm.data,"height":_vm.height,"summary-method":_vm.summary},on:{"sort-change":function($event){return _vm.$emit('on-sort', $event)}}},_vm._l((_vm.columns),function(col,id){return _c('el-table-column',{key:id,attrs:{"prop":col.key,"label":col.title,"fixed":col.fixed,"show-overflow-tooltip":col.overflow,"min-width":col.width,"align":col.align,"sortable":col.sortable,"sort-orders":['descending', 'ascending', null]},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(['pv', 'clickNum', 'paperUseAmount', 'amount', 'newRoleMoney'].includes(col.key))?_c('span',[_vm._v(" "+_vm._s(_vm._f("toThousands")(scope.row[col.key]))+" ")]):(
          [
            'clickRate',
            'payRoleUserRate',
            'newRoleRate',
            'nextDayRetainRate',
            'threeDayRetainRate',
            'sevenDayRetainRate',
            'thirtyDayRetainRate',
            'createRoleTwoDayRetainRate',
            'createRoleThreeDayRetainRate',
            'createRoleFourDayRetainRate',
            'createRoleFiveDayRetainRate',
            'createRoleSixDayRetainRate',
            'createRoleSevenDayRetainRate',
            'createRoleTenDayRetainRate',
            'createRoleFifteenDayRetainRate',
            'createRoleThirtyDayRetainRate',
            'createRole24hRoi',
            'createRoleRoi1d',
            'createRoleRoi3d',
            'createRoleRoi7d'
          ].includes(col.key)
        )?_c('span',[_vm._v(_vm._s(_vm._f("toPercentFixed")(scope.row[col.key]))+" ")]):_c('span',[_vm._v(_vm._s(scope.row[col.key]))])]}}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }